import { restClient } from '../../client';


export type FinancesTotal = {
  payout: number;
  hasCalculationsWarning: number;

  cashpayItemsCount: number;
  insuranceItemsCount: number;
  lateFeeSessionsCount: number;
  submittedItemsCount: number;
};


export const getFinancesTotal = async (providerId: string) => restClient.request<{
  data: FinancesTotal;
}>(`/api/v1/provider/${providerId}/finances/total`);
